import {
    Brands,
    Companies,
    Drafts,
    Factions,
    Feuds,
    Gimmicks,
    StaffMembers,
    Superstars,
    TagTeams
} from "./models.js";

function Roster(type) {

    // Foreign keys
    const companyId = null;
    const draftId = null;
    const currentDraftPickId = null;

    return {
        type,
        companyId,
        draftId,
        currentDraftPickId,
    };
}

function getRosterSuperstars(roster) {
    return Superstars.find({'rosterId': roster.$loki});
}

function addRosterSuperstars(roster, superstars) {
    superstars.forEach(c => {
        c.rosterId = roster.$loki
    });
}

function removeRosterSuperstars(roster, superstars) {
    superstars.forEach(c => {
        c.rosterId = null
    });
}

function getRosterTagTeams(roster) {
    return TagTeams.find({'rosterId': roster.$loki});
}

function addRosterTagTeams(roster, tagTeams) {
    tagTeams.forEach(c => {
        c.rosterId = roster.$loki
    });
}

function removeRosterTagTeams(roster, tagTeams) {
    tagTeams.forEach(c => {
        c.rosterId = null
    });
}

function getRosterOriginalSuperstars(roster) {
    return Superstars.find({'originalRosterId': roster.$loki});
}

function addRosterOriginalSuperstars(roster, superstars) {
    superstars.forEach(c => {
        c.originalRosterId = roster.$loki
    });
}

function removeRosterOriginalSuperstars(roster, superstars) {
    superstars.forEach(c => {
        c.originalRosterId = null
    });
}

function getRosterCompany(roster) {
    return Companies.find({'$loki': roster.companyId})[0];
}

function getRosterBrands(roster) {
    return Brands.find({'rosterId': roster.$loki});
}

function addRosterBrands(roster, brands) {
    brands.forEach(c => {
        c.rosterId = roster.$loki
    });
}

function removeRosterBrands(roster, brands) {
    brands.forEach(c => {
        c.rosterId = null
    });
}

function getRosterFactions(roster) {
    return Factions.find({'rosterId': roster.$loki});
}

function addRosterFactions(roster, factions) {
    factions.forEach(c => {
        c.rosterId = roster.$loki
    });
}

function removeRosterFactions(roster, factions) {
    factions.forEach(c => {
        c.rosterId = null
    });
}

function getRosterFeuds(roster) {
    return Feuds.find({'rosterId': roster.$loki});
}

function addRosterFeuds(roster, feuds) {
    feuds.forEach(c => {
        c.rosterId = roster.$loki
    });
}

function removeRosterFeuds(roster, feuds) {
    feuds.forEach(c => {
        c.rosterId = null
    });
}

function getRosterGimmicks(roster) {
    return Gimmicks.find({'rosterId': roster.$loki});
}

function addRosterGimmicks(roster, gimmicks) {
    gimmicks.forEach(c => {
        c.rosterId = roster.$loki
    });
}

function removeRosterGimmicks(roster, gimmicks) {
    gimmicks.forEach(c => {
        c.rosterId = null
    });
}

function getRosterStaff(roster) {
    return StaffMembers.find({'rosterId': roster.$loki});
}

function addRosterStaff(roster, staff) {
    staff.forEach(c => {
        c.rosterId = roster.$loki
    });
}

function removeRosterStaff(roster, staff) {
    staff.forEach(c => {
        c.rosterId = null
    });
}

function getRosterDraft(roster) {
    return Drafts.find({'$loki': roster.draftId})[0];
}


export { Roster, getRosterSuperstars, addRosterSuperstars, removeRosterSuperstars, getRosterTagTeams,
    addRosterTagTeams, removeRosterTagTeams, getRosterOriginalSuperstars, addRosterOriginalSuperstars,
    removeRosterOriginalSuperstars, getRosterCompany, getRosterBrands, addRosterBrands, removeRosterBrands,
    getRosterFactions, addRosterFactions, removeRosterFactions, addRosterFeuds, removeRosterFeuds,
    getRosterFeuds, addRosterGimmicks, removeRosterGimmicks, getRosterGimmicks, addRosterStaff, removeRosterStaff,
    getRosterStaff };